import {
  usePrefetchQuery as usePrefetchHomeQuery,
  getQueryKey as getHomeQueryKey,
} from "@faire/web-api/api/v2/layout/home/get-hooks";
import React, { lazy, useEffect } from "react";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export const HOMEPAGE_LAYOUT_API_STALE_TIME = 1 * 60 * 1000;
export const LazyLoggedInHome: React.FC = () => {
  const prefetchHome = usePrefetchHomeQuery();

  useEffect(() => {
    prefetchHome(undefined, {
      queryKey: getHomeQueryKey(),
      staleTime: HOMEPAGE_LAYOUT_API_STALE_TIME,
    });
  }, [prefetchHome]);

  return <LazyLoggedInHomeBase />;
};

const LazyLoggedInHomeBase = lazy(() =>
  import(
    /* webpackChunkName: "retailer-logged-in-home" */
    "@faire/retailer/views/home/logged-in-homepage/LoggedInHome"
  )
    .then((m) => ({ default: m.LoggedInHome }))
    .catch(handleComponentLoadError)
);
